import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as CategoryCreators } from 'store/categories/categories-duck.js';

const CategoryModal = ({
  isOpen,
  subCategoryToUpdate,
  categoryId,
  subCategoriesCloseModal,
  categoriesAddSubCategoryAsync,
  subCategoriesUpdateAsync,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues: { name: '' } });

  useEffect(() => {
    if (isOpen) {
      reset(subCategoryToUpdate);
    } else {
      reset({ name: '' });
    }
  }, [isOpen, subCategoryToUpdate, reset]);

  const onSubmit = async (data) => {
    if (subCategoryToUpdate?.id) {
      subCategoriesUpdateAsync({ id: subCategoryToUpdate.id, ...data });
    } else {
      categoriesAddSubCategoryAsync(categoryId, data);
    }
    subCategoriesCloseModal();
  };

  return (
    <Dialog open={isOpen} onClose={subCategoriesCloseModal} fullWidth maxWidth="sm">
      <DialogTitle>
        {subCategoryToUpdate?.id ? 'Editar Sub-Categoria' : 'Nova Sub-Categoria'}
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Nome"
          variant="filled"
          fullWidth
          margin="normal"
          error={!!errors.name}
          helperText={errors.name?.message}
          {...register('name', { required: 'O nome é obrigatório' })}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={subCategoriesCloseModal} color="secondary">
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit(onSubmit)}
          color="primary"
          variant="contained"
          disabled={isSubmitting}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.Category.isSubCategoryModalOpen,
  categoryId: state.Category.categoryId,
  subCategoryToUpdate: state.Category.subCategoryToUpdate,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(CategoryCreators, dispatch);
CategoryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  subCategoryToUpdate: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  categoryId: PropTypes.string.isRequired,
  subCategoriesCloseModal: PropTypes.func.isRequired,
  categoriesAddSubCategoryAsync: PropTypes.func.isRequired,
  subCategoriesUpdateAsync: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryModal);
